const isObject = require('./is-object')

/*
 * (object, object) => object
 *
 * recursively replaces a given object's values with a given
 * overwrite object's values, while leaving unspecified properties
 * intact
 * */

function overwriteDeep (initial, overwrite) {
  function reducer (reduction, [ key, value ]) {
    /*
     * in order to go a level in the recursion deeper a couple
     * of conditions need to be met:
     *
     * - the initial value needs to be an object: if it's not
     * it's safe to just overwrite it with whatever the value
     * the overwrite-object is
     *
     * - the overwrite value needs to be an object: if it was
     * an object on the initial-object but is not anymore,
     * there's no need for recursion and we just replace the
     * value with the new primitive
     * 
     * - the current key needs to be in the initial-object: if
     * it's not it means that it's a new property and it's safe
     * to assign directly without digging in recursively
     */
    if (isObject(initial[ key ]) && isObject(value) && key in initial) {
      return {
        ...reduction,
        [ key ]: overwriteDeep(initial[ key ], value)
      }
    }

    return { ...reduction, [ key ]: value }
  }

  return Object.entries(overwrite).reduce(reducer, initial)
}

module.exports = overwriteDeep
